var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0140CD",
    d: "M11.25 7.5c.414 0 .75.338.75.754v1.883c0 .897-.464 1.562-1.298 1.828-.073.023-.15.035-.226.035H1.524c-.077 0-.153-.012-.226-.035C.464 11.699 0 11.035 0 10.137V8.254C0 7.838.336 7.5.75 7.5c.415 0 .75.338.75.754v1.883c0 .207 0 .37.378.37h8.298c.288 0 .32-.129.323-.303v-1.95c0-.416.336-.754.75-.754zM6.75 0c.414 0 .75.329.75.735V4.5h1.497c.485 0 .746.654.423 1.009l-3 3.306c-.223.247-.617.247-.84 0l-3-3.306C2.257 5.154 2.516 4.5 3 4.5H4.5V.735C4.5.329 4.836 0 5.25 0h1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d926e9ea3a6d00ea18cb532efbcf0279.svg";
export { ForwardRef as ReactComponent };